<template>
    <div class="w-fit p-2 ml-3 mb-4 bg-base-100 border border-base-300">
        <input v-model="numNewEntities" class="bg-transparent outline-none" autocomplete="off">
        <button class="btn btn-primary btn-sm" :disabled="isLoading" @click="handleAddMany"> {{ isLoading ? 'Laster' : 'Opprett mange' }}</button>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import {notifyError} from '@/services/infrastructure/notification.service'
import {generateAssignments} from '@/dummy-generator/DummyGenerator.service'
import emitter from '@/services/infrastructure/emitter'
import {ASSIGNMENT_CREATED} from '@/assignments/assignment.service'

const isLoading = ref(false)

const numNewEntities = ref(10)

const handleAddMany = async () => {
    isLoading.value = true
    try {
        await generateAssignments(numNewEntities.value)
        emitter.emit(ASSIGNMENT_CREATED)
    } catch (error) {
        notifyError({title: 'Feilet', description: {descriptionMessage: `Klarte ikke å generere ${numNewEntities.value} oppgaver.`, error}})
    } finally {
        isLoading.value = false
    }
}
</script>

<style>

</style>